import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ContentDesktopComponent } from './components/content-desktop/content-desktop.component';
import { ContentMobileComponent } from './components/content-mobile/content-mobile.component';
import { RouterLoadingSpinnerComponent } from './components/router-loading-spinner/router-loading-spinner.component';
import { NavbarComponent } from './components/content-desktop/components/navbar/navbar.component';
import { BackendStateInformationComponent } from './components/backend-state-information/backend-state-information.component';
import { DataCategoryService } from './components/services/data-category.service';
import { TestEnvBlockComponent } from './components/test-env-block/test-env-block.component';
import {ClientSideRenderingDirective} from '../../common/directives/client-side-rendering.directive';
import {BackendStateService} from '../../common/services/backend-state.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'header[raHeader]',
  standalone: true,
  imports: [
    CommonModule,
    NavbarComponent,
    ContentDesktopComponent,
    ContentMobileComponent,
    RouterLoadingSpinnerComponent,
    BackendStateInformationComponent,
    TestEnvBlockComponent,
    ClientSideRenderingDirective,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  // backendStatus$ = this._backendState.status$;

  envName = environment.environmentName;

  constructor(
    private _backendState: BackendStateService,
    private dataCategoryService: DataCategoryService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  closeModal() {
    this.dataCategoryService.setNewStatus(false);
  }
}
